import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { CountMode } from '../../components/ReportBarChart/types';

export const useCountModeLabels = () => {
  const { t } = useTranslation();

  const countModeLabels: Record<CountMode, string> = {
    total: t('Total'),
    per_plant: t('Per plant'),
  };

  return countModeLabels;
};
